import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("crm");

export const crmTransport = transport;
export const CRM_BASE_URL = baseUrl;
